/**
 * Row that behaves like a slider with every column being a slide below certain breakpoint.
 *
 * Uses SwiperJS to make slider draggable on touch devices.
 */
import dom from '../helpers/dom';

const sliderRow = (element) => {
  const breakpoint = 980; // From: assets/src/scss/public/breakpoints.scss.
  let swiperInstance;
  let isEnabled = false;

  const screenBelowBreakpoint = () => {
    const windowWidth = window.innerWidth;
    return windowWidth <= breakpoint;
  };

  const enable = () => {
    if (!isEnabled) {
      swiperInstance = new Swiper(element, {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 32,
        grabCursor: true,
        pagination: {
          el: '.qusd-slider-row__pagination',
          clickable: true,
        },
      });
      element.classList.add('qusd-slider-row--enabled');
      isEnabled = true;
    }
  };

  const disable = () => {
    if (isEnabled) {
      swiperInstance.destroy();
      element.classList.remove('qusd-slider-row--enabled');
      isEnabled = false;
    }
  };

  return {
    init: () => (screenBelowBreakpoint() ? enable() : disable()),
    update: () => (screenBelowBreakpoint() ? enable() : disable()),
  };
};

const sliderRows = () => {
  const sliderRowClass = 'js-qusd-slider-row';
  const sliderRowInstances = [];
  let sliderRowElements;
  let sliderRowsFound = false;

  const init = () => {
    sliderRowElements = dom.getByClassName(sliderRowClass);
    sliderRowsFound = sliderRowElements !== null;

    if (sliderRowsFound) {
      sliderRowElements.forEach((sliderRowElement, index) => {
        sliderRowInstances[index] = sliderRow(sliderRowElement);
        sliderRowInstances[index].init();
      });
    }
  };

  const onResize = () => {
    if (sliderRowsFound) {
      sliderRowInstances.forEach((sliderRowInstance) => {
        sliderRowInstance.update();
      });
    }
  };

  return {
    init,
    onResize,
  };
};

export default sliderRows();
